import { render, staticRenderFns } from "./LabelSideBar.vue?vue&type=template&id=e6478ee0&scoped=true&"
import script from "./LabelSideBar.vue?vue&type=script&lang=ts&"
export * from "./LabelSideBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6478ee0",
  null
  
)

export default component.exports